import cx from "classnames"
import PropTypes from "prop-types"
import React from "react"
import circleCheckIcon from "../../assets/icons/circle-check.svg"

function CircleCheckList({ className, children }) {
  return (
    <ul
      className={cx(
        className,
        "grid grid-cols-1 gap-y-8 gap-x-5 md:grid-cols-2 lg:gap-x-20"
      )}
    >
      {children}
    </ul>
  )
}

export function ListItem({ children }) {
  return (
    <li className="flex items-center gap-x-4 text-xl text-dark-grey">
      <img className="h-9 w-9" src={circleCheckIcon} alt="Check icon" />
      <div className="flex-1">{children}</div>
    </li>
  )
}

CircleCheckList.propTypes = {
  /** Additional className(s) */
  className: PropTypes.string,
  /** List content */
  children: PropTypes.node,
}

export default CircleCheckList
